import React from 'react';
import { FeatureRow } from './FeatureRow';
import { MONO } from '../../constants/fonts';

function FounderSection() {
  return (
    <section style={s.founderSection}>
      <div style={s.founderInner}>
        <div style={s.founderBadge}>
          <span style={s.founderDot} />
          Founding client offer
        </div>
        <h2 style={s.founderHeadline}>Get in early.</h2>
        <p style={s.founderSub}>
          We're building our portfolio. To do that, we need great clients we can shout about, and we're prepared to make it worth your while.
        </p>
        <div className="care-grid" style={{ ...s.careGrid, marginTop: 32 }}>
          <div style={s.founderCard}>
            <p style={s.founderCardTitle}>What you get</p>
            <div style={{ ...s.featureList, gap: 12 }}>
              <FeatureRow light label="We'll go above and beyond." included />
              <FeatureRow light label="First 3 months of your care plan, completely free" included />
              <FeatureRow light label="Ongoing care plan at the standard rate from the fourth month" included />
            </div>
          </div>
          <div style={s.founderCard}>
            <p style={s.founderCardTitle}>What we ask in return</p>
            <div style={{ ...s.featureList, gap: 12 }}>
              <FeatureRow light label="A testimonial we can use on our website and socials" included />
            </div>
          </div>
        </div>
        <p style={s.founderNote}>
          This is agreed in writing at kickoff. Three months of Essential care is £135. That's what this costs us. In return, you get proof we deliver, and we get the portfolio that lets us grow.
        </p>
      </div>
    </section>
  );
}

const s = {
  founderSection: {
    background: '#f9f9f7',
    padding: 'clamp(56px, 8vw, 96px) 24px',
    borderTop: '1px solid #ebebeb',
  },
  founderInner: {
    maxWidth: 800,
    margin: '0 auto',
  },
  founderBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    fontFamily: MONO,
    fontSize: '0.72rem',
    fontWeight: 600,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#f59e0b',
    background: 'rgba(245,158,11,0.08)',
    border: '1px solid rgba(245,158,11,0.2)',
    borderRadius: 20,
    padding: '5px 14px',
    marginBottom: 20,
  },
  founderDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: '#f59e0b',
    boxShadow: '0 0 8px rgba(245,158,11,0.5)',
    flexShrink: 0,
  },
  founderHeadline: {
    fontSize: 'clamp(1.8rem, 5vw, 2.8rem)',
    fontWeight: 800,
    letterSpacing: '-0.03em',
    color: '#1c1c1e',
    margin: '0 0 16px',
  },
  founderSub: {
    fontSize: '0.96rem',
    color: '#6b6b6b',
    lineHeight: 1.7,
    maxWidth: 520,
    margin: 0,
  },
  careGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
  },
  founderCard: {
    background: '#fff',
    border: '1px solid #ebebeb',
    borderRadius: 16,
    padding: '24px',
  },
  founderCardTitle: {
    fontFamily: MONO,
    fontSize: '0.7rem',
    fontWeight: 600,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#9ca3af',
    margin: '0 0 16px',
  },
  founderNote: {
    marginTop: 24,
    fontSize: '0.82rem',
    color: '#9ca3af',
    lineHeight: 1.7,
    textAlign: 'center',
  },
  featureList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
};

export default FounderSection;
